import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './styles/jbrowse-theme.css';
import './styles/workspace.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  spacing: 8,
  shape: { borderRadius: 8 },
  palette: {
    primary: { main: '#111827' },
    background: { default: '#fafbfc', paper: '#ffffff' },
  },
  typography: {
    fontFamily: 'Manrope, system-ui, sans-serif',
    h4: { fontSize: '2rem', lineHeight: '2.5rem', fontWeight: 700 },
    h5: { fontSize: '1.5rem', lineHeight: '2rem', fontWeight: 700 },
    h6: { fontSize: '1.125rem', lineHeight: '1.5rem', fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { styleOverrides: { root: { minHeight: 48, padding: '8px 16px' } } },
    MuiIconButton: { styleOverrides: { root: { minWidth: 48, minHeight: 48 } } },
    MuiTab: { styleOverrides: { root: { minHeight: 48, textTransform: 'none' } } },
    MuiOutlinedInput: { styleOverrides: { root: { minHeight: 48 } } },
    MuiSelect: {
      styleOverrides: {
        icon: { right: 14, width: 20, height: 20 },
        select: { paddingRight: '44px !important' },
      },
    },
    MuiNativeSelect: {
      styleOverrides: {
        icon: { right: 14, width: 20, height: 20 },
        select: { paddingRight: '44px' },
      },
    },
    MuiTableCell: { styleOverrides: { root: { padding: 16 } } },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
